import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberWithCommas'
})
export class CurrencyMaskPipe implements PipeTransform {
  transform(val = '') {
    if (val && typeof val === 'string') {
      val = this.format_number(val, '');
      return val;
    }
  }

  format_number(number, prefix) {
    let lang = localStorage.getItem('__language');
    let thousand_separator = ',';
    let decimal_separator = '.';
    let regex = new RegExp('[^' + decimal_separator + '\\d]', 'g');
    let number_string = number.replace(regex, '').toString();
    let split = number_string.split(decimal_separator);
    let rest = split[0].length % 3;
    let result = split[0].substr(0, rest);
    let thousands = split[0].substr(rest).match(/\d{3}/g);

    if (thousands) {
      let separator = rest ? thousand_separator : '';
      result += separator + thousands.join(thousand_separator);
    }
    result = split[1] != undefined ? result + decimal_separator + split[1] : result;
    return prefix == undefined ? result : (result ? prefix + result : '');
  };
}
